<ul class="social-menu" data-cy="social-media">
  <li *ngFor="let socialMediaItem of socialMediaItems">
    <a href={{socialMediaItem.fields.link}}>
      <i class="social-menu__icon fa fa-{{socialMediaItem.fields.title.toLowerCase()}}"></i>
    </a>
  </li>
</ul>
